<template>
  <div class="FOOTER">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'blueprint-footer',
};
</script>

<style lang="scss" scoped>
.FOOTER {
  flex: none;
}
</style>
